export default __webpack_public_path__ + "static/media/sidebar_submissions_blue.4ee4583c.svg";